import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL
import Grid from '@material-ui/core/Grid'

// EXTRA COMPONENTS
import SkewBg from './SkewBg'
import SimpleParagraphWButton from '../../Utilities/SimpleParagraphWButton'

// import CardNFC from './CardNFC'
// import CardNFC from './CardNFC'

// IMAGES
import PortfolioShowOff from '../../../assets/PortfolioShowOff.png'

export default class PortfolioPart extends React.Component{
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render(){
    return(
        <section id="Portfolio" className={css(styles.MainContainer)}>
            <SkewBg />
            <div className="container">
                <section className={css(styles.SecondaryContainer)}>
                    <Grid spacing="40" container alignItems="center">
                        <Grid item md={4} xs={12} className={css(styles.container)}>
                            <SimpleParagraphWButton title="Portfolio" subtitle="What we do" text="Some of our most recent and relevant work, from mobile apps to ethereum smart contracts" />
                        </Grid>
                        <Grid item md={8}>
                            <img className={css(styles.PortfolioImg)} src={PortfolioShowOff} alt=""/>
                        </Grid>
                    </Grid>
                </section>
            </div>
        </section>
    )
  }
}

const styles = StyleSheet.create({
    MainContainer: {
        position: 'relative',
    },
    SecondaryContainer: {
        paddingTop: '35%',
    	color: 'white',
        lineHeight: '1.8em',
        '@media (max-width: 768px)':{
            paddingTop: '100%'
        }
    },
    introButton: {
        color: 'white',
        width: 180,
        background: 'linear-gradient(-161deg, #FF6B4D, #D85944)',
        borderRadius: 200,
        lineHeight: 0,
        paddingRight: '10px',
        marginTop: '5%',
        boxShadow: '0 18px 35px rgba(50,50,93,.1), 0 8px 15px rgba(0,0,0,.07)',
        transition: 'all ease-in-out .2s',
        ':hover':{
            transform: 'translate(0, -2px)',
            boxShadow: '0 20px 40px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
    rightArrow: {
        backgroundColor: '#F7FCFF',
        color: '#7047D6',
        borderRadius: '188px',
        fontSize: '31px',
        padding: '5px',
        marginLeft: '15px'
    },
    PortfolioImg: {
        pointerEvents: 'none',
        maxHeight: 350,
        cursor: 'pointer',
        filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))',
        zIndex: 100
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/PortfolioPart/PortfolioPart.js